import React from 'react';
import { useLocale } from 'locale';
import { WithContentSlotSidePaddingContainer } from 'ds/components/Layout';
import styled from '@emotion/styled';
import { Text, SmallText } from 'ds/components/typography';
import { Table } from 'ds/components/table';
import { InsightType } from 'utils/entities';
import { ShowAt } from 'consts/breakpoints';
import { PricesTableColumn } from 'components/widget/prices/prices-table/utils';
import { LiensSummaryData, LiensItem } from 'store/state/selectors/insights/summaryTypes';

const Subtitle = styled(Text)`
  margin-bottom: 48px;
  ${({ theme }) => theme.media.showAt({ at: 1 }) `
    margin-bottom: 32px;
  `}
`;

interface LiensSummaryProps {
  data: LiensSummaryData;
}

export const LiensSummary: React.FC<LiensSummaryProps> = ({ data }) => {
  const { t, formatDate } = useLocale();

  return (
    <WithContentSlotSidePaddingContainer>
      <Subtitle dangerouslySetInnerHTML={{ __html: data.text }} />
      <ShowAt at={1}>
        {matches => (
          <Table<LiensItem>
            paginationType="infinite"
            data={data.data}
            visibleRows={10}
            wrapColumnText
            insightType={InsightType.Prices}
            columns={[
              {
                label: t('widget.prices.tableColumnTitle', { title: PricesTableColumn.Date }),
                sortFn: (items) => items.sort((a, b) => +new Date(b.date) - +new Date(a.date)),
                renderFn: (item) => (
                  <SmallText style={{ alignSelf: 'flex-start' }}>
                    {formatDate(item.date)}
                  </SmallText>
                ),
                width: matches ? '50%' : '25%',
                gap: matches ? 8 : 24,
              },
              {
                label: t('liensSummary.holder'),
                sortFn: (items) => items.sort((a, b) => b.holder.localeCompare(a.holder)),
                renderFn: (item) => (
                  <SmallText>
                    {item.holder}
                  </SmallText>
                ),
                width: matches ? '50%' : '75%',
              },
            ]}
          />
        )}
      </ShowAt>
    </WithContentSlotSidePaddingContainer>
  );
};
